import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#A0A0A0",
      d: "M18.094.516C16.74.204 14.515 0 12 0S7.26.204 5.906.516a6.99 6.99 0 0 0-5.39 5.39C.204 7.26 0 9.485 0 12s.204 4.74.516 6.094a6.99 6.99 0 0 0 5.39 5.39C7.26 23.796 9.485 24 12 24s4.74-.204 6.094-.516a6.99 6.99 0 0 0 5.39-5.39C23.796 16.74 24 14.515 24 12s-.204-4.74-.516-6.094a6.99 6.99 0 0 0-5.39-5.39"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M8.5 11.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5z" }),
  /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 8, r: 1, fill: "#fff" }),
  /* @__PURE__ */ React.createElement("circle", { cx: 18, cy: 8, r: 1, fill: "#fff" })
);
var SvgSentimentNeutralFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SentimentNeutralFilled_default = SvgSentimentNeutralFilled;

export { SentimentNeutralFilled_default as default };
